/* eslint-disable no-undef */
import moment from 'moment-timezone';
import Polyglot from 'node-polyglot';
import $ from 'jquery';
import { localeForMoment } from '../../shared/helpers/Dates';

// Matches special characters, and instances of more than one apostrophe
const SPECIAL_CHARS = /(')\w+\1|[()[\]{}0-9;:!@#$%^&*_+~`|=<>,?\/"]/g;

// customize time formats
moment.updateLocale('en', {
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'dddd MMMM D, YYYY',
    LLL: 'MMMM D, YYYY LT',
    LLLL: 'dddd, MMMM D, YYYY LT',
  },
});

moment.updateLocale('fr', {
  longDateFormat: {
    LT: 'HH[h]mm',
    LTS: 'LT:ss',
    L: 'DD/MM/YYYY',
    LL: 'dddd D MMMM, YYYY',
    LLL: 'D MMMM YYYY LT',
    LLLL: 'dddd D MMMM YYYY LT',
  },
});

const lang = $('html').attr('lang');
moment.locale(localeForMoment(lang) || 'en');

const polyglot = new Polyglot({
  phrases: window.TRANSLATIONS,
  allowMissing: true,
});

function current(format) {
  return moment().format(format);
}

function currentLanguage() {
  const lang = document.documentElement.getAttribute('lang');

  return (lang || 'en').toUpperCase();
}

function format(timestamp, format, zone = false) {
  const timezone = window.TIMEZONE;
  let date = zone ? moment.parseZone(timestamp) : moment(timestamp);

  if (timezone) {
    date = date.tz(timezone);
  }

  return date.format(format);
}

function param(name) {
  const url = window.location.href;
  const key = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${key}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function trans(key, options) {
  return polyglot.t(key, options);
}

function timezone() {
  return moment().tz(window.TIMEZONE || moment.tz.guess()).format('z');
}

export { current, currentLanguage, format, param, SPECIAL_CHARS, trans, timezone };
export default { current, currentLanguage, format, param, SPECIAL_CHARS, trans, timezone };
